export const baseURL = 'https://technoserver.ghairmulki.com/api/v1';
// export const baseURL = 'http://localhost:5100/api/v1';
// export const staticFilesURL = 'http://localhost:5100';
export const staticFilesURL = 'https://technoserver.ghairmulki.com';